/** @format */

import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { MenuDirective } from "./menu.directive";
import { OverlayModule } from "@angular/cdk/overlay";
import { PortalModule } from "@angular/cdk/portal";

@NgModule({
  declarations: [MenuDirective],
  imports: [CommonModule, OverlayModule, PortalModule],
  exports: [MenuDirective]
})
export class MisMenuModule {}
